<div class="h-full">
    <nz-layout style="height: 100%;">
        <nz-sider [nzWidth]="isLargeScreen() ? 200 : 40" class="menu-sider">
            <ul nz-menu nzMode="inline" [nzInlineCollapsed]="!isLargeScreen()">
                @if(showNavMenuOption('machines', 'machinesDashboard')) {
                <li nz-menu-item (click)="setActiveTab('machines-dashboard')"
                    [nzSelected]="activeTab() === 'machines-dashboard'">
                    <span nz-icon nzType="user"></span>
                    <span [hidden]="!isLargeScreen()">Máquinas</span>
                </li>
                }
                <li nz-menu-item (click)="setActiveTab('operators-history')"
                    [nzSelected]="activeTab() === 'operators-history'">
                    <span nz-icon nzType="user"></span>
                    <span [hidden]="!isLargeScreen()">Histórico de operarios</span>
                </li>
                @if (showButton('btnPrismaPerfomanceMeter')) {
                <li nz-menu-item (click)="setActiveTab('prisma-meter')" [nzSelected]="activeTab() === 'prisma-meter'">
                    <span nz-icon nzType="user"></span>
                    <span [hidden]="!isLargeScreen()">Medidor rendimiento Prisma</span>
                </li>
                }
            </ul>
        </nz-sider>
        <nz-layout>
            @if(activeTab() === 'operators-history') {
            <nz-content class="pt-4 bg-white" nzVisible="activeTab() === 'operators-history'">                
                <app-operators-history-dashboard></app-operators-history-dashboard>
            </nz-content>
            }
            @if(activeTab() === 'prisma-meter') {
            <nz-content class="pt-4 bg-white" nzVisible="activeTab() === 'prisma-meter'">
                <app-prisma-performance-meter></app-prisma-performance-meter>
            </nz-content>
            }
            @if(showNavMenuOption('machines', 'machinesDashboard') && activeTab() === 'machines-dashboard') {
            <nz-content class="pt-4 bg-white" nzVisible="activeTab() === 'machines-dashboard'">
                <app-machines-dashboard></app-machines-dashboard>
            </nz-content>
            }
        </nz-layout>
    </nz-layout>
</div>